import EmailTemplate from "./EmailTemplate"

export default function EmailTemplates({
  emailTemplates,
  orderEx
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
      {emailTemplates?.map(e => 
        <div>
          <div>{e.name}</div>
          <EmailTemplate key={e.name} emailTemplateId={e.id} orderEx={orderEx} />
        </div>
      )}
    </div>
  )
}